import { render } from "./about.vue?vue&type=template&id=3b328d10&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=3b328d10&lang=css"
import "./about.vue?vue&type=style&index=1&id=3b328d10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b328d10"]])

export default __exports__